import React, { Component } from "react";
import { setMenuTopIndex, setMenuLeftContent, setMenuLeftIndex } from "../../../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import Limits from "../../../containers/admin/premium/LimitsBonuses";
import MenuPresence from "../Menu";
import AuthRender from "../../../containers/AuthRender";
import { SERVICES } from "../../../configs/constants";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("presence");
    this.props.setMenuLeftContent(MenuPresence);
    this.props.setMenuLeftIndex("limit");
  }

  render() {
    return (
      <AuthRender service={SERVICES.Primes}>
        <Limits {...this.props} />
      </AuthRender>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setMenuLeftContent: data => {
      dispatch(setMenuLeftContent(data));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/presence/premium/Limits.js